<template>
  <div class="device-configuration">
    <div class="devices">
      <div class="deivice-all">
        <div class="devices-search">
          <customer-trees ref="customerTrees" @getByUser="getByUser"></customer-trees>
          <!-- 项目分组组件 -->
          <project-trees ref="projectTrees" @clickProject="clickProject" @clickDevice="clickDevice"
            @projectChange="projectChange"></project-trees>
        </div>
        <div class="devices-tree">
          <el-tree v-loading="deviceLoading" :data="devicesTreeOption" @node-click="clickDevice" node-key="deviceDid"
            ref="devicesTrees" highlight-current :element-loading-text="$t('lang.Monitor.loading')"
            element-loading-spinner="el-icon-loading" :props="devicesTreeProps">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <el-tag size="small" type="success" v-if="data.deviceIsconnected == 3">{{
                $t("lang.Monitor.connected")
              }}</el-tag>
              <el-tag size="small" type="danger" v-else>{{
                $t("lang.Monitor.disconnected")
              }}</el-tag>
              <span style="font-size: 16px">{{ node.label }}（{{
                data.deviceName ? data.deviceName : "N/A"
              }}）</span>
            </span>
          </el-tree>
        </div>
      </div>
    </div>
    <div class="centerInfo">
      <div :class="centerTopClass">
        <!-- 变量展示组件 -->
        <center-params :deviceDid="deviceItem.deviceDid" :deviceId="deviceItem.deviceId"
          :groupMonitorType="groupMonitorType" @enLarge="enLarge">
        </center-params>
      </div>
      <!-- 详细信息模块 -->
      <div :class="centerBottomClass">
        <i class="icon-quanping Qp-Icon" style="float: right" @click="enLarge"></i>
        <div class="centerInfo-bottom_top">
          <div class="centerInfo-bottom_top--left">
            <div>
              <el-radio-group size="mini" v-model="radio">
                <el-radio-button :label="$t('lang.Monitor.deviceInfo')"></el-radio-button>
                <el-radio-button v-if="Permission.indexOf(227) !== -1"
                  :label="$t('lang.Monitor.historyData')"></el-radio-button>
                <el-radio-button v-if="Permission.indexOf(228) !== -1"
                  :label="$t('lang.Monitor.historyAlarm')"></el-radio-button>
              </el-radio-group>
            </div>
            <div v-if="radio !== $t('lang.Monitor.deviceInfo')" class="tab">
              <el-select v-model="computedSearch['dtuid']" :placeholder="$t('lang.Monitor.terminal')" size="mini"
                style="width: 150px;" clearable>
                <el-option v-for="(item, index) in terminalOptions" :key="index" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <el-select style="width: 100px;" v-model="computedSearch['vid']" :placeholder="$t('lang.Monitor.variable')"
                size="mini" clearable>
                <el-option v-for="(item, index) in paramsOptions" :key="index" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <el-date-picker size="mini" v-model="computedSearch['time']" type="datetimerange" style="width: 300px;"
                :range-separator="$t('lang.Monitor.to')" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
              <el-button size="mini" type="primary" @click="queryData">
                {{ $t("lang.Monitor.search") }}
              </el-button>
              <xlsx @exportExcel="exportExcel" ref="xlsx" :wait="xlsxWait"></xlsx>
              <!-- <el-button
                style="margin-left: 5px; margin-top: -5px"
                size="mini"
                type="primary"
                @click="exportClick"
              >
                {{ $t("lang.Monitor.export") }}
              </el-button> -->
            </div>
          </div>
        </div>
        <div class="detail">
          <device-detail v-if="radio === $t('lang.Monitor.deviceInfo')" :deviceItem="deviceItem"></device-detail>
          <history-data ref="historyData" v-if="radio === $t('lang.Monitor.historyData') &&
            Permission.indexOf(227) !== -1
            " :deviceItem="deviceItem" :searchData="dataSearchData">
          </history-data>
          <history-alarm ref="historyAlarm" v-if="radio === $t('lang.Monitor.historyAlarm') &&
            Permission.indexOf(228) !== -1
            " :searchData="alarmSearchData" :deviceItem="deviceItem">
          </history-alarm>
        </div>
      </div>
    </div>
    <!-- 实时报警数据 -->
    <div :class="bottomEnlarge === true || topEnlarge === true
      ? 'right-alarm_enlarge'
      : 'right-alarm'
      ">
      <div class="right-alarm_top">
        <span style="font-size: 16px; font-weight: bolder">{{
          $t("lang.Monitor.realTimeAlarm")
        }}</span>
      </div>
      <div class="right-alarm_scroll">
        <div class="right-alarm_bottom">
          <right-alarm :deviceDid="deviceItem.deviceDid"></right-alarm>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import deviceDetail from "./components/deviceDetail";
import historyAlarm from "./components/historyAlarm/index";
import historyData from "./components/historyData";
import projectTrees from "../../../components/projectTrees";
import customerTrees from "../../../components/customerTrees";
import rightAlarm from "./components/rightAlarm/index";
import centerParams from "./components/centerParams/index";
import { getFirstGroup, getSecondGroup } from "@/api/cloudMonitor/projectGroup";
import { getListByGroup } from "@/api/cloudMonitor/deviceList";
import { getByDevice } from "@/api/cloudMonitor/terminalList";
import { getParamsByterminal } from "@/api/cloudMonitor/paramsList";
import { deleteParams } from "@/api/cloudMonitor/dashboard";
import moment from "moment";
import { getPermission } from "@/cookie/cookie";
import { getuser_iscustomer, getuser_ctid } from "@/localStorage/localStorage";
import xlsx from "@/components/xlsx";
export default {
  data() {
    return {
      // 设备列表的筛选值
      deviceSearch: "",
      // 搜索表单
      dataSearchData: {
        dtuid: "", // 选择的终端
        vid: "", // 选择的变量id
        time: [],
      },
      // 历史报警搜索表单
      alarmSearchData: {
        dtuid: "", // 选择的终端
        vid: "", // 选择的变量id
        time: [],
      },
      // 终端选择的选项
      terminalOptions: [],
      // 变量选项
      paramsOptions: [],
      // 点击设备列表后选中的设备项
      deviceItem: {},
      // 项目选择下拉框
      projectSearch: {},
      projectOptions: [],
      radio: this.$t("lang.Monitor.deviceInfo"),
      devicesTreeOption: [],
      devicesTreeProps: {
        label: "deviceSn",
      },
      // 是否放大
      bottomEnlarge: false,
      topEnlarge: false,
      deviceLoading: false,
      // 待删除的变量
      deleteSelections: [],
      Permission: [],
      // 客户id
      customerId: "",
      user_iscustomer: getuser_iscustomer(),
      user_ctid: getuser_ctid(),
      groupMonitorType: 0, //项目类型
      // 客户选择列表
      // customerList: [],
      xlsxWait: true
    };
  },
  components: {
    deviceDetail,
    historyAlarm,
    projectTrees,
    historyData,
    rightAlarm,
    centerParams,
    customerTrees,
    xlsx,
  },
  computed: {
    // 放大按钮操作样式
    centerTopClass() {
      if (this.topEnlarge === false && this.bottomEnlarge === false) {
        return "centerInfo-top";
      } else if (this.bottomEnlarge) {
        // 中心顶部块区隐藏
        return "centerInfo-top_hidden";
      } else if (this.topEnlarge) {
        // 中心顶部块区放大
        return "centerInfo-bottom_enlarge";
      }
    },
    centerBottomClass() {
      if (this.topEnlarge === false && this.bottomEnlarge === false) {
        return "centerInfo-bottom";
      } else if (this.bottomEnlarge) {
        // 中心底部块区放大
        return "centerInfo-bottom_enlarge";
      } else if (this.topEnlarge) {
        // 中心底部块区隐藏
        return "centerInfo-bottom_hidden";
      }
    },
    // 计算搜索框绑定的变量
    computedSearch() {
      if (this.radio === this.$t("lang.Monitor.historyData")) {
        return this.dataSearchData;
      } else if (this.radio === this.$t("lang.Monitor.historyAlarm")) {
        return this.alarmSearchData;
      }
    },
    selectProject(e) {
      console.log(e);
    },
    // variableType(){
    // 判断变量类型
    // }
  },
  watch: {
    computedSearch: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val && val.dtuid) {
          // 获取终端对应的变量
          this.getTermianlParams();
        }
      },
    },
    radio: {
      immediate: true,
      handler() {
        if (this.radio !== this.$t("lang.Monitor.deviceInfo")) {
          // 获取设备对应的终端列表
          if (this.deviceItem.deviceDid) {
            this.getDeviceTerminals().then(() => {
              this.$refs["historyData"].queryKeyword()
            })
          }
        }
      },
    },
  },
  mounted() {
    this.Permission = getPermission();
  },
  // activated() {
  //   console.log('设备组态activated');
  // },
  // deactivated() {
  //   console.log('设备组态离开');
  // },
  destroyed() {
    this.clearData();
  },
  methods: {
    //重置数据
    clearData() {
      this.deleteSelections = [];
      this.dataSearchData = {
        dtuid: "", // 选择的终端
        vid: "", // 选择的变量id
        time: [],
      };
      this.terminalOptions = [];
      this.paramsOptions = [];
      this.radio = this.$t("lang.Monitor.deviceInfo");
      let time2 = new Date();
      let time1 = new Date().setDate(time2.getDate() - 1);
      this.dataSearchData.time = [time1, new Date(time2)];
      this.alarmSearchData.time = [time1, new Date(time2)];
      this.devicesTreeOption = [];
    },
    // 点击扩展符
    enLarge(type) {
      if (type === "top") {
        // 顶部放大，底部隐藏
        this.topEnlarge = !this.topEnlarge;
      } else {
        this.bottomEnlarge = !this.bottomEnlarge;
      }
    },
    // 点击设备
    clickDevice(node) {
      this.deviceItem = node;
      // this.deviceDid =
      if (this.radio !== this.$t("lang.Monitor.deviceInfo")) {
        this.dataSearchData.dtuid = "";
        this.dataSearchData.vid = "";
        this.alarmSearchData.dtuid = "";
        this.alarmSearchData.vid = "";
        // 获取设备对应的终端列表和变量
        if (this.deviceItem.deviceDid) {
          this.getDeviceTerminals();
        }
      }
    },
    // 项目分组根据用户Id查询
    getByUser(userId) {
      this.clearData();
      this.$refs.projectTrees.getByUser(userId);
    },
    // 获取某个终端的变量
    getTermianlParams() {
      let params =
        this.radio === this.$t("lang.Monitor.historyData") &&
          this.dataSearchData.dtuid
          ? this.dataSearchData.dtuid
          : this.alarmSearchData.dtuid;
      if (params) {
        getParamsByterminal(params).then((res) => {
          if (res.data.code === 0) {
            this.paramsOptions = res.data.data;
            // 设置默认值
            if (this.radio === this.$t("lang.Monitor.historyData")) {
              if (!this.dataSearchData.vid) {
                this.dataSearchData.vid =
                  this.paramsOptions.length > 0 ? this.paramsOptions[0].id : "";
              }
            } else if (this.radio === this.$t("lang.Monitor.historyAlarm")) {
              if (!this.alarmSearchData.vid) {
                this.alarmSearchData.vid =
                  this.paramsOptions.length > 0 ? this.paramsOptions[0].id : "";
              }
            }
          }
        });
      }
    },
    // 获取某个设备下的终端列表
    getDeviceTerminals() {
      return new Promise((resolve, reject) => {
        let params = {
          pageParam: {
            current: 1,
            size: 99999,
          },
          dtuInfo: {
            did: this.deviceItem.deviceDid,
          },
        };
        getByDevice(params).then((res) => {
          if (res.data.code === 0) {
            let data = res.data.data;
            this.terminalOptions = data.records;
            // 设置默认值
            if (this.radio === this.$t("lang.Monitor.historyData")) {
              if (!this.dataSearchData.dtuid) {
                this.dataSearchData.dtuid =
                  this.terminalOptions.length > 0
                    ? this.terminalOptions[0].id
                    : "";
              }
            } else if (this.radio === this.$t("lang.Monitor.historyAlarm")) {
              if (!this.alarmSearchData.dtuid) {
                this.alarmSearchData.dtuid =
                  this.terminalOptions.length > 0
                    ? this.terminalOptions[0].id
                    : "";
              }
            }
            resolve()
          }
        });
      });
    },
    // 点击项目节点
    clickProject(node) {
      // 切换了之后，就重置所有数据
      this.clearData();
      let params = {
        pageParam: {
          current: 1,
          size: 99999,
        },
        deviceInfo: {
          deviceGid: node.groupId,
        },
      };
      this.groupMonitorType = node.groupMonitorType;
      this.deviceLoading = true;
      // 获取设备列表
      getListByGroup(params).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data;
          this.devicesTreeOption = data.records;
          this.deviceLoading = false;
          if (this.devicesTreeOption.length > 0) {
            let node = "";
            // 每次进来都刷新一次分组下的设备，有可能删除/增加设备后回到此页面，需要刷新
            // 若存在上一次缓存设备则设置选中，否则重新选择第一个设备
            if (this.deviceItem.deviceDid) {
              node = this.devicesTreeOption.find((item) => {
                return item.deviceDid === this.deviceItem.deviceDid;
              });
            }
            if (!node) {
              this.deviceItem = this.devicesTreeOption[0];
            }
            //若没有存在的话， 设置第一个设备为选中状态
            this.$nextTick(() => {
              this.$refs.devicesTrees.setCurrentKey(this.deviceItem.deviceDid);
            });
          } else {
            this.deviceItem = {};
          }
        }
      });
    },
    // 项目分组发生变化
    projectChange() {
      this.deviceItem = {};
    },
    // 点击查询
    queryData() {
      if (this.radio === this.$t("lang.Monitor.historyData")) {
        if (!this.dataSearchData.dtuid) {
          this.$message.warning(this.$t("lang.Monitor.pleaseTerminal"));
          return false;
        }
        if (!this.dataSearchData.vid) {
          this.$message.warning(this.$t("lang.Monitor.pleaseVariable"));
          return false;
        }
        this.$refs.historyData.queryKeyword();
      } else if (this.radio === this.$t("lang.Monitor.historyAlarm")) {
        if (!this.alarmSearchData.dtuid) {
          this.$message.warning(this.$t("lang.Monitor.pleaseTerminal"));
          return false;
        }
        if (!this.alarmSearchData.vid) {
          this.$message.warning(this.$t("lang.Monitor.pleaseVariable"));
          return false;
        }
        this.$refs.historyAlarm.queryKeyword();
      }
    },
    exportClick() {
      console.log(this.radio);
      if (this.radio == this.$t("lang.Monitor.historyData")) {
      } else if (this.radio == this.$t("lang.Monitor.historyAlarm")) {
      }
    },
    async exportExcel() {
      if (this.radio === this.$t('lang.Monitor.historyData')) {
        await this.$refs.historyData.exportData()
      } else if (this.radio === this.$t('lang.Monitor.historyAlarm')) {
        await this.$refs.historyAlarm.exportData()
      }
      this.xlsxWait = false;
      this.$refs.xlsx.exportExcel2();
      this.xlsxWait = true;
      if (this.radio === this.$t('lang.Monitor.historyData')) {
        await this.$refs.historyData.queryKeyword()
      } else if (this.radio === this.$t('lang.Monitor.historyAlarm')) {
        await this.$refs.historyAlarm.queryKeyword()
      }
    }
  },
};
</script>
<style scoped>
.device-configuration {
  display: flex;
  width: 100%;
  height: 74vh;
  margin-top: 20px;
  gap: 10px;
}

.devices-tree {
  width: calc(100% - 20px);
  overflow: auto;
  margin-left: 10px;
  max-height: calc(100% - 50px);
}

.devices,
.centerInfo-top,
.centerInfo-bottom,
.centerInfo-bottom_enlarge,
.right-alarm,
.right-alarm_enlarge {
  border: 2px solid rgb(0, 116, 199);
  background-color: #e9edfa;
}

.devices {
  width: 20%;
  flex-shrink: 0;
}


.centerInfo-top {
  /* height: 35vh; */
  height: 35vh;
  padding: 10px 0 20px 10px;
  overflow: hidden;
  flex-shrink: 0;
}

/* 顶部隐藏 */
.centerInfo-top_hidden {
  display: none;
}

/* 顶部放大*/
.centerInfo-top_enlarge {
  height: 70vh;
  padding: 10px 0 20px 10px;
  overflow: hidden;
}

.centerInfo-bottom {
  position: relative;
  /* height: 35vh; */
  height: 100%;
  margin-top: 10px;
  padding: 0px 0 0 10px;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

/* 底部放大 */
.centerInfo-bottom_enlarge {
  position: relative;
  padding: 10px 0 20px 10px;
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex: 1;
}

/* 底部隐藏 */
.centerInfo-bottom_hidden {
  display: none;
}

.centerInfo-bottom_top {
  line-height: 40px;
  margin-bottom: 20px;
  display: flex;
}

.centerInfo-bottom_top--left {
  display: flex;
  flex-wrap: wrap;
}

.deviceSearch {
  margin-left: 10px;
}

.centerInfo {
  width: 45vw;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.right-alarm {
  width: 20%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 放大后要调节大小 */
.right-alarm_enlarge {
  width: 20%;
  /* margin-left: 10px; */
  overflow: hidden;
}

.detail {
  padding-top: 10px;
  /* height: 65%; */
  height: 85%;
  overflow-y: scroll;
  margin-bottom: 10px;
}

.el-tree {
  background-color: transparent;
  margin-top: 10px;
  margin-right: 10px;
}

.detail-search {
  width: 1.8rem;
}

.Qp-Icon {
  position: absolute;
  font-size: 18px;
  font-weight: bolder;
  color: rgb(0, 116, 199);
  cursor: pointer;
  right: 10px;
  top: 10px;
}

.deivice-all,
.centerInfo-top_scroll {
  height: 95%;
  overflow: scroll;
  width: 95%;
}

.deivice-all {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.right-alarm_bottom {
  height: 98%;
}

.right-alarm_top {
  margin: 15px 0;
  text-align: center;
  flex-shrink: 0;
}

.right-alarm_scroll {
  overflow: auto;
  flex: 1;
}

::-webkit-scrollbar-track-piece {
  background-color: #e9edfa;
}

::-webkit-scrollbar-corner {
  background-color: #e9edfa;
}

.tab {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
}

.devices-search {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 10px;
}
</style>
